<style>
ul.step-items {
  list-style-type: none !important;
}
</style>

<template>
  <div class="card" style="width: 900px;overflow: auto;">
    <div class="card-modal" style="overflow: auto">
      <b-loading :is-full-page="true" v-model="loading" :can-cancel="false">
      </b-loading>

      <header class="modal-card-head">
        <p class="modal-card-title">User Upload Form</p>
        <button type="button" class="delete" @click="$emit('close')"></button>
      </header>
      <section>
        <br />
        <b-steps
          type="is-primary"
          v-model="activeStep"
          :animated="isAnimated"
          :rounded="isRounded"
          :has-navigation="hasNavigation"
          :icon-prev="prevIcon"
          :icon-next="nextIcon"
          :label-position="labelPosition"
          :mobile-mode="mobileMode"
        >
          <b-step-item
            step="1"
            label="Download Excel Template"
            :clickable="isStepsClickable"
          >
            <!-- <h1 class="title has-text-centered">Download Excel Template</h1> -->
            <br />
            <div class="container is-widescreen">
              <b-message type="is-info">
                Download the below excel template and add your users.
                <strong>DO NOT</strong> change the column headers.
                <strong>Click Next</strong> to upload your completed
                spreadsheet.
              </b-message>
            </div>
            <br />
            <span class="is-centered"
              ><center>
                <h5 class="title is-5">
                  <a :href="templateUrlExcel">Click Here</a> to download Excel
                  template
                </h5>
              </center>
            </span>
          </b-step-item>

          <b-step-item
            step="2"
            label="Upload File"
            :clickable="isStepsClickable"
          >
            <br />

            <br />

            <b-message
              type="is-danger"
              v-if="validationErrors.length > 0"
              style=" text-align: left; "
            >
              <h4 class="is-size-4">Please correct the following errors:</h4>
              <div class="content" style="overflow:auto;height:100px;">
                <ul>
                  <li v-for="(e, index) in validationErrors" :key="index">
                    Row {{ e.row }} -
                    <span v-for="msg in e.errors" :key="msg">{{ msg }}</span>
                  </li>
                </ul>
              </div>
            </b-message>

            <b-field class="file is-primary" :class="{ 'has-name': !!file }">
              <b-upload
                v-model="file"
                class="file-label"
                required
                accept=".xlsx"
                validationMessage="Please select a file"
                ref="fileElement"
              >
                <span class="file-cta">
                  <b-icon class="file-icon" icon="upload"></b-icon>
                  <span class="file-label">Click to upload completed file</span>
                </span>
                <span class="file-name" v-if="file">
                  {{ file.name }}
                </span>
              </b-upload> </b-field
            ><br />
            <div class="columns">
              <div class="column">
                <b-field>
                  <template #label>
                    Update record if email address already exists
                    <b-tooltip type="is-dark" position="is-left" multilined>
                      <b-icon
                        size="is-small"
                        icon="help-circle-outline"
                      ></b-icon>

                      <template v-slot:content>
                        If selected 'No', the record will be skipped
                      </template>
                    </b-tooltip>
                  </template>
                  <b-switch v-model="updateExistingRecord">
                    {{ updateExistingRecord ? "Yes" : "No" }}
                  </b-switch>
                </b-field>
              </div>
            </div>
            <b-button
              v-if="file"
              @click="uploadFile()"
              :disabled="!isFormValid"
              type="is-primary"
              expanded
              >Submit File</b-button
            >
          </b-step-item>
          <template v-if="customNavigation" #navigation="{previous, next}">
            <b-button
              class="is-pulled-left ml-2"
              outlined
              type="is-danger"
              icon-pack="fas"
              icon-left="backward"
              :disabled="previous.disabled"
              @click.prevent="previous.action"
            >
              Previous </b-button
            >&nbsp;
            <b-button
              class="is-pulled-right mr-2"
              outlined
              type="is-success"
              icon-pack="fas"
              icon-right="forward"
              :disabled="next.disabled"
              @click.prevent="next.action"
            >
              Next </b-button
            >&nbsp;&nbsp;
          </template>
          <br /><br />
        </b-steps>
      </section>
      <br />
      <footer class="modal-card-foot"></footer>
    </div>
  </div>
</template>

<script>
export default {
  props: ["profile"],

  data() {
    return {
      loading: false,
      validationErrors: [],
      file: null,
      createTcCreds: false,
      updateExistingRecord: false,

      activeStep: 0,

      isAnimated: true,
      isRounded: true,
      isStepsClickable: false,

      hasNavigation: true,
      customNavigation: true,
      isProfileSuccess: true,

      prevIcon: "chevron-left",
      nextIcon: "chevron-right",
      labelPosition: "bottom",
      mobileMode: "minimalist",
    };
  },
  methods: {
    uploadFile() {
      this.validationErrors = [];
      this.loading = true;

      var data = new FormData();
      data.append("import_file", this.file);
      data.append("updateExistingRecords", this.updateExistingRecord);
      data.append("createTcCreds", this.createTcCreds);

      data.append("contactId", this.profile.id);

      //   var headers ={'Content-Type': 'multipart/form-data'};

      this.$app
        .huddleLabsServerCall1("profile/contacts/upload", data)
        .then((result) => {
          if (!result.error) {
            if (!result.success) {
              if (result.importFailures)
                this.validationErrors = result.importFailures;
              this.file = null;

              this.loading = false;
            } else {
              this.loading = false;
              this.success();
              this.$emit("upload-success");
              this.$emit("close");
            }

            console.log(result);
            // this.users = result.data;
            this.loading = false;
          } else {
            console.log(result);
            this.loading = false;
          }
        })
        .catch((error) => {
          this.loading = false;
          this.file = null;
          console.log(error);
        });
    },

    success() {
      this.$buefy.toast.open({
        message:
          "File successfully uploaded and will be synced in the next few minutes.",
        type: "is-success",
      });
    },
    failure() {
      this.$buefy.toast.open({
        duration: 5000,
        message: "There was an error saving uploading your file",
        position: "is-bottom",
        type: "is-danger",
      });
    },
  },
  mounted() {},
  computed: {
    templateUrlExcel() {
      return "/files/UserListUpload.xlsx";
    },

    isFormValid() {
      return this.file != null;
    },
  },
};
</script>
